module.exports = __webpack_public_path__ + "fc77a798.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ListCoverPhoto/medium_no_image.png
// module id = 2770
// module chunks = 15